import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=b2249fb0&lang=pug&"
import script from "./Part.vue?vue&type=script&lang=js&"
export * from "./Part.vue?vue&type=script&lang=js&"
import style0 from "./Part.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
